import UtilsFncs from "utils/UtilsFncs.js";
import IconButton from "@material-ui/core/IconButton";
import { FileCopy, MailOutline } from "@mui/icons-material";

const commonStyle = { marginLeft: 5, marginBottom: 1 };

export default function EmailText({
  email = "",
  showSend = true,
  showCopy = true,
}) {
  return (
    email &&
    email.trim() > "" && (
      <>
        {email}
        {showSend && (
          <IconButton size="small" href={"mailto:" + email} target="_blank">
            <MailOutline fontSize="small" style={commonStyle} />
          </IconButton>
        )}
        {showCopy && (
          <IconButton
            title="Copiar"
            size="small"
            onClick={() => {
              UtilsFncs.CopyToClipboard(email);
            }}
          >
            <FileCopy fontSize="small" style={commonStyle} />
          </IconButton>
        )}
      </>
    )
  );
}
